import type { HeadFC, PageProps } from 'gatsby';
import { graphql } from 'gatsby';
import type { FC } from 'react';
import type { ProductsListing } from '../../../@types/gql/products-listing';
import type { SEOEntity } from '../../../@types/gql/seo';
import ProductCategoryList from '../../../components/product/categories';
import ProductCategoryInfo from '../../../components/product/categories/category-info';
import ProductListingByCategory from '../../../components/product/categories/products';
import ProductSubCategoryList from '../../../components/product/categories/sub-categories';
import SEOComponent from '../../../components/shared/seo';
import Breadcrumb from '../../../components/shared/breadcrum';

export const query = graphql`
  query ProductsListingQuery($subCategory: String!, $category: String!) {
    allStrapiCategory(sort: { position: ASC }) {
      nodes {
        Title
        Slug
      }
    }
    allStrapiSubCategory(
      filter: { Category: { Slug: { eq: $category } } }
      sort: { position: ASC }
    ) {
      nodes {
        Title
        Slug
       
      }
    }
    strapiSubCategory(Slug: { eq: $subCategory }) {
      seo {
        ...SEOFragment
      }
      Title
      Description
     
    }
    allStrapiProduct(
      filter: { Category: { Slug: { eq: $subCategory } } }
      sort: { position: ASC }
    ) {
      nodes {
        id
        Title
        Thumbnail {
          url
        }
        Slug
        subCategory: Category {
          Slug
          VideoUrl
          Category {
            Slug
          }
        }
        Description
      }
    }
  }
`;

const ProductCategoryTemplate: FC<
  PageProps<ProductsListing, { category: string; subCategory: string, slug:string }>
> = ({ data, pageContext,location }) => {

  console.log("ProductCategoryTemplate",data)

  return (
    <div>
      <div className="py-14 bg-[#fff]">
        <Breadcrumb items={[]} />
        <ProductCategoryList
          categories={data.allStrapiCategory}
          category={pageContext.category}
        />
        <div className="container px-6 mx-auto grid gap-3 sm:grid-cols-12">
          <div className="sm:col-span-3">
            <ProductSubCategoryList
              category={pageContext.category}
              subCategories={data.allStrapiSubCategory}
              location={location}
            />
          </div>
          <div className="sm:col-span-9">
            <ProductCategoryInfo {...data.strapiSubCategory} />
            <ProductListingByCategory products={data.allStrapiProduct} />
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryTemplate;

export const Head: HeadFC<{
  strapiSubCategory: { seo?: SEOEntity };
}> = ({ data }) => <SEOComponent seo={data.strapiSubCategory.seo} />;
